import { Check, Plus } from "lucide-react";
import { useEffect, useState } from "react";

import { api, rows } from "../lib/api";
import type { ApiList, ModuleActivation, ModuleDefinition } from "../lib/types";

export function ModulesPage() {
  const [catalogue, setCatalogue] = useState<ModuleDefinition[]>([]);
  const [activations, setActivations] = useState<ModuleActivation[]>([]);

  async function load() {
    const [c, a] = await Promise.all([
      api.get<ApiList<ModuleDefinition>>("/api/v1/modules/catalogue/"),
      api.get<ApiList<ModuleActivation>>("/api/v1/modules/activations/")
    ]);
    setCatalogue(rows(c));
    setActivations(rows(a));
  }
  useEffect(()=>{void load();},[]);

  async function toggle(module: ModuleDefinition) {
    const activation = activations.find((a)=>a.module===module.id);
    if (activation) await api.patch(`/api/v1/modules/activations/${activation.id}/`, {actif:!activation.actif});
    else await api.post("/api/v1/modules/activations/", {module:module.id,actif:true,configuration:{},quotas:{}});
    await load();
  }

  return <div><div><div className="text-sm font-semibold text-emerald-700">Architecture modulaire</div><h1 className="mt-1 text-3xl font-black">Modules</h1><p className="mt-2 text-sm text-slate-500">Activez les capacités dont l’entreprise a réellement besoin.</p></div><div className="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-3">{catalogue.map((module)=>{const active=activations.find((a)=>a.module===module.id)?.actif;return <article key={module.id} className="panel p-5"><div className="flex items-start justify-between"><div><div className="text-xs font-mono text-slate-400">{module.code}</div><h2 className="mt-1 text-lg font-bold">{module.nom}</h2></div><span className={`grid size-9 place-items-center rounded-xl ${active?"bg-emerald-100 text-emerald-700":"bg-slate-100 text-slate-500"}`}>{active?<Check size={18}/>:<Plus size={18}/>}</span></div><p className="mt-3 min-h-10 text-sm text-slate-500">{module.description}</p>{module.code==="TIERS"?<div className="mt-5 rounded-xl bg-slate-100 px-3 py-2.5 text-center text-sm font-bold text-slate-600">Socle obligatoire</div>:<button onClick={()=>void toggle(module)} className={active?"btn-secondary mt-5 w-full":"btn-primary mt-5 w-full"}>{active?"Désactiver":"Activer"}</button>}</article>})}</div></div>;
}
